"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mixins = require("../../../_helpers/mixins");

var _CountrySelector = _interopRequireDefault(require("../../misc/CountrySelector"));

var _FormInput = _interopRequireDefault(require("../../../blocks/FormInput"));

var _StatusText = _interopRequireDefault(require("../../../elements/StatusText"));

var _icons = require("../../../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    left: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    padding-left: 50px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const WideIcon = (0, _styledComponents.default)(_FormInput.default.Icon).withConfig({
  displayName: "WideIcon"
})(["max-width:67px;", ";"], ({
  theme
}) => (0, _mixins.media)(theme.breakpoints.sm)(_templateObject()));
const WideIconInput = (0, _styledComponents.default)(_FormInput.default.Input).withConfig({
  displayName: "WideIconInput"
})(["padding-left:132px;", ";"], ({
  theme
}) => (0, _mixins.media)(theme.breakpoints.sm)(_templateObject2()));

const CountrySelectorWrap = _styledComponents.default.div.withConfig({
  displayName: "CountrySelectorWrap"
})(["position:absolute;top:50%;left:78px;transform:translateY(-50%);", ";"], ({
  theme
}) => (0, _mixins.media)(theme.breakpoints.sm)(_templateObject3()));

const EmailPhoneInput = ({
  error,
  onChange,
  onCountryChange,
  placeholder
}) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormInput.default, null, /*#__PURE__*/_react.default.createElement(WideIcon, {
  src: _icons.envelopePhoneSvg
}), /*#__PURE__*/_react.default.createElement(CountrySelectorWrap, null, /*#__PURE__*/_react.default.createElement(_CountrySelector.default, {
  _countrySelectHandler: onCountryChange
})), /*#__PURE__*/_react.default.createElement(WideIconInput, {
  modifiers: [error ? 'error' : null],
  onChange: onChange,
  placeholder: placeholder
})), error ? /*#__PURE__*/_react.default.createElement(_StatusText.default, {
  modifiers: ['error']
}, error) : null);

EmailPhoneInput.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  onCountryChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string,
  placeholder: _propTypes.default.string
};
EmailPhoneInput.defaultProps = {
  error: '',
  placeholder: 'Email or phone number'
};
var _default = EmailPhoneInput;
exports.default = _default;